<p *ngIf="showDocumentError">
  Sorry, there was an error retrieving your document. Please check your email
  for a copy of this document or contact us at (833) 684-0466 if you need immediate assistance.
</p>